export default __webpack_public_path__ + "2fd2b774b95b997ffd501a7849780316.png";